import * as actionTypes from './actionTypes';

export const fetchAllContacts = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllContactsSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});


export const fetchAllContactsBySpaceId = (spaceId) => ({
  type: actionTypes.FETCH_ALL_BY_SPACE_ID,
  spaceId,
});
export const fetchAllContactsBySpaceIdSuccess = (ids, spaceId) => ({
  type: actionTypes.FETCH_ALL_BY_SPACE_ID_SUCCESS,
  ids,
  spaceId,
});


export const fetchContactByUserId = (userId) => ({
  type: actionTypes.FETCH_BY_USER_ID,
  userId,
});
export const fetchContactByUserIdSuccess = (id) => ({
  type: actionTypes.FETCH_BY_USER_ID_SUCCESS,
  id,
});


export const downloadVcard = (contact) => ({
  type: actionTypes.DOWNLOAD_VCARD,
  contact,
});
export const downloadVcardSuccess = (contact) => ({
  type: actionTypes.DOWNLOAD_VCARD_SUCCESS,
  contact,
});


export const createContact = (contact) => ({
  type: actionTypes.CREATE,
  contact,
});
export const createContactSuccess = (contact) => ({
  type: actionTypes.CREATE_SUCCESS,
  contact,
});


export const deleteContact = (contact) => ({
  type: actionTypes.DELETE,
  contact,
});
export const deleteContactSuccess = (id) => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});


export const updateContact = (contact) => ({
  type: actionTypes.UPDATE,
  contact,
});
export const updateContactSuccess = (contact) => ({
  type: actionTypes.UPDATE_SUCCESS,
  contact,
});


export const setActiveContactId = (id) => ({
  type: actionTypes.SET_ACTIVE_CONTACT_ID,
  id,
});


export const fetchMyContact = () => ({
  type: actionTypes.FETCH_ME,
});
export const fetchMyContactSuccess = (id) => ({
  type: actionTypes.FETCH_ME_SUCCESS,
  id,
});


export const updateMyContact = (contact) => ({
  type: actionTypes.UPDATE_ME,
  contact,
});
export const updateMyContactSuccess = (id) => ({
  type: actionTypes.UPDATE_ME_SUCCESS,
  id,
});

export const importContacts = (csv) => ({
  type: actionTypes.IMPORT,
  csv,
});
export const importContactsSuccess = (ids) => ({
  type: actionTypes.IMPORT_SUCCESS,
  ids,
});
